import { render } from "./pb-links.vue?vue&type=template&id=7f559696"
import script from "./pb-links.vue?vue&type=script&lang=js"
export * from "./pb-links.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__